import React, { useState } from 'react';
import { connect } from 'react-redux';
import { List, Tag, Tooltip, Icon, Alert, Button, message } from 'antd';
import moment from 'moment';
import get from 'lodash/get';
import * as drawerLeadsActions from '../actions';

var getCategoryName = function(category) {
  switch (parseInt(category)) {
    case 1: return 'Abertura de Empresa';
    case 2: return 'Alteração Contratual';
    case 3: return 'Encerramento de Empresa';
    case 4: return 'Tarefa esporádica';
    case 5: return 'Troca de Contabilidade (entrada)';
    case 6: return 'Outros';
    case 7: return 'Troca de Contabilidade (saída)';
    default: return 'Ticket';
  }
};

var getStageName = function(stage) {
  switch (parseInt(stage)) {
    case 1: return 'Leads';
    case 2: return 'Oportunidade';
    case 3: return 'Positivo';
    case 4: return 'Negativo';
    case 5: return 'Follow Up';
    default: return 'Desconhecido';
  }
};

var getStatusTag = function(dashTask) {
  if (get(dashTask, 'deleted_at')) {
    return <Tag color="red">Excluído</Tag>;
  } else if (get(dashTask, 'finalized_at')) {
    return <Tag color="green">Finalizado</Tag>;
  } else if (get(dashTask, 'processed_at')) {
    return <Tag color="blue">Em andamento</Tag>;
  } else {
    return <Tag color="orange">Cadastrado</Tag>;
  }
};

var SocietarioTab = function(props) {
  var dashTasks = props.dashTasks || [];
  var dashTasksWithTrashed = props.dashTasksWithTrashed || [];
  var stage = props.stage;
  var necessity = props.necessity;
  var leadId = props.leadId;
  var createDashtask = props.createDashtask;

  var [loading, setLoading] = useState(false);

  var openSocietarioInNewTab = function(taskId) {
    window.open('/societario?task_id=' + taskId, '_blank');
  };

  // Check if there are deleted tickets
  var deletedTasks = dashTasksWithTrashed.filter(function(task) {
    return task.deleted_at !== null;
  });
  var hasDeletedTasks = deletedTasks.length > 0;
  var hasActiveTasks = dashTasks.length > 0;

  var handleCreateDashtask = function() {
    setLoading(true);
    createDashtask(leadId)
      .then(function() {
        message.success('Ticket societário criado com sucesso!');
      })
      .catch(function(error) {
        var errorMessage = get(error, 'error.response.data.message') || 'Erro ao criar ticket societário';
        message.error(errorMessage);
      })
      .finally(function() {
        setLoading(false);
      });
  };

  // Show empty state with explanation
  if (!hasActiveTasks) {
    var alertMessage = '';
    var description = '';
    var type = 'info';
    var showButton = false;

    if (stage === 4) {
      alertMessage = 'Lead marcado como Negativo';
      description = 'Este lead foi marcado como negativo e não possui ticket societário vinculado.';
      type = 'warning';
    } else if (stage !== 3) {
      alertMessage = 'Lead ainda não foi positivado';
      description = 'O ticket societário é criado automaticamente quando o lead é movido para a coluna "Positivo". Atualmente o lead está em "' + getStageName(stage) + '".';
      type = 'info';
    } else if (!necessity) {
      alertMessage = 'Necessidade não definida';
      description = 'Para criar o ticket societário, é necessário definir a "Necessidade" do lead (ex: Abertura de Empresa, Troca de Contabilidade, etc.) na aba "Lead".';
      type = 'warning';
    } else if (hasDeletedTasks) {
      alertMessage = 'Ticket excluído';
      description = 'O ticket societário deste lead foi excluído. Você pode criar um novo ticket clicando no botão abaixo.';
      type = 'error';
      showButton = true;
    } else {
      alertMessage = 'Nenhum ticket encontrado';
      description = 'Este lead está positivado mas não possui ticket societário vinculado. Clique no botão abaixo para criar o ticket manualmente.';
      type = 'warning';
      showButton = true;
    }

    return (
      <div style={{ padding: '20px 0' }}>
        <Alert
          message={alertMessage}
          description={description}
          type={type}
          showIcon
        />
        {hasDeletedTasks && (
          <div style={{ marginTop: 16 }}>
            <p style={{ marginBottom: 8, color: '#666', fontSize: 13 }}>Tickets excluídos:</p>
            <List
              size="small"
              dataSource={deletedTasks}
              renderItem={function(item) {
                return (
                  <List.Item style={{ padding: '8px 0' }}>
                    <span style={{ color: '#999' }}>
                      <Icon type="delete" style={{ marginRight: 8 }} />
                      {getCategoryName(item.category)} #SOC{item.id}
                      <span style={{ marginLeft: 8 }}>
                        (excluído em {item.deleted_at && moment(item.deleted_at).format('DD/MM/YYYY')})
                      </span>
                    </span>
                  </List.Item>
                );
              }}
            />
          </div>
        )}
        {showButton && (
          <div style={{ marginTop: 16, textAlign: 'center' }}>
            <Button
              type="primary"
              icon="plus"
              loading={loading}
              onClick={handleCreateDashtask}
            >
              Criar Novo Ticket Societário
            </Button>
          </div>
        )}
      </div>
    );
  }

  return (
    <List
      itemLayout="horizontal"
      dataSource={dashTasks}
      renderItem={function(item) {
        return (
          <List.Item
            style={{ cursor: 'pointer', padding: '12px 16px' }}
            onClick={function() { openSocietarioInNewTab(item.id); }}
          >
            <List.Item.Meta
              avatar={
                <div style={{
                  width: 40,
                  height: 40,
                  borderRadius: '50%',
                  backgroundColor: '#f0f0f0',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <Icon type="file-text" style={{ fontSize: 18, color: '#1890ff' }} />
                </div>
              }
              title={
                <span>
                  {getCategoryName(item.category)}
                  <span style={{ marginLeft: 8, color: '#999', fontSize: 12 }}>
                    #SOC{item.id}
                  </span>
                </span>
              }
              description={
                <span>
                  {getStatusTag(item)}
                  <span style={{ marginLeft: 8, color: '#666' }}>
                    {item.created_at && moment(item.created_at).format('DD/MM/YYYY')}
                  </span>
                </span>
              }
            />
            <Tooltip title="Abrir em nova aba">
              <Icon type="export" style={{ color: '#999' }} />
            </Tooltip>
          </List.Item>
        );
      }}
    />
  );
};

var mapDispatchToProps = function(dispatch) {
  return {
    createDashtask: function(leadId) {
      return dispatch(drawerLeadsActions.createDashtask(leadId));
    }
  };
};

export default connect(null, mapDispatchToProps)(SocietarioTab);
